module.exports = __webpack_public_path__ + "media/下载测试版APP指引（iOS）.5075941.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/下载测试版APP指引（iOS）.mp4
// module id = f7WW
// module chunks = 3